<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
  >
    <div
      class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between"
    >
      <div class="trezo-card-title">
        <h5 class="mb-0">{{ directT('ecommerce.orderDetails.billingDetails') }}</h5>
      </div>
    </div>
    <div class="trezo-card-content">
      <ul>
        <li class="mb-[12px] last:mb-0">
          <span class="text-black dark:text-white font-medium"> {{ directT('ecommerce.orderDetails.name') }}: </span>
          {{ order?.name || 'N/A' }}
        </li>
        <li class="mb-[12px] last:mb-0">
          <span class="text-black dark:text-white font-medium"> {{ directT('ecommerce.orderDetails.email') }}: </span>
          {{ order?.email || 'N/A' }}
        </li>
        <li class="mb-[12px] last:mb-0">
          <span class="text-black dark:text-white font-medium"> {{ directT('ecommerce.orderDetails.phone') }}: </span>
          {{ order?.phone || 'N/A' }}
        </li>
        <li class="mb-[12px] last:mb-0">
          <span class="text-black dark:text-white font-medium"> {{ directT('ecommerce.orderDetails.address') }}: </span>
          {{ order?.address || 'N/A' }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { useI18n } from "vue-i18n";
import enTranslations from "@/i18n/locales/en.json";
import heTranslations from "@/i18n/locales/he.json";
import arTranslations from "@/i18n/locales/ar.json";
import { Order } from "@/services/orderService";

// Type definition for translation objects
type TranslationObject = {
  [key: string]: string | TranslationObject;
};

export default defineComponent({
  name: "BillingDetails",
  props: {
    order: {
      type: Object as PropType<Order | null>,
      required: true
    }
  },
  setup() {
    // i18n setup
    const { locale } = useI18n();
    
    // Translation files
    const translationFiles = {
      en: enTranslations,
      he: heTranslations,
      ar: arTranslations
    };
    
    // Direct translation function that bypasses vue-i18n
    const directT = (key: string): string => {
      const parts = key.split('.');
      let result: TranslationObject = translationFiles[locale.value as keyof typeof translationFiles];
      
      for (const part of parts) {
        if (!result || !(part in result)) {
          console.warn(`Missing translation key: ${key} in ${locale.value} locale`);
          // Fallback to English if translation not found
          let enResult: TranslationObject = translationFiles.en;
          for (const fallbackPart of parts) {
            if (!enResult || !(fallbackPart in enResult)) return key;
            enResult = enResult[fallbackPart as keyof typeof enResult] as TranslationObject;
          }
          return typeof enResult === 'string' ? enResult : key;
        }
        result = result[part as keyof typeof result] as TranslationObject;
      }
      return typeof result === 'string' ? result : key;
    };
    
    return {
      directT
    };
  }
});
</script>
